import React from "react";
import "./contact.css";
import { motion } from "framer-motion/dist/framer-motion";

const Contact = () => {
  return (
    <div class="contact" id="contacts">
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Contacts
      </motion.h1>
      <p className="sub-head">
        If you have questions or even any regards about me and my services,
        Please write me below;
      </p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="contact-view"
      >
        <div className="contact-left">
          <div className="contact-list">
            <img
              src="https://ideal-jupiter.com/wp-content/uploads/2018/12/location-1.png"
              alt="icon-img"
            />
            <div>
              <p className="title">Location:</p>
              <p className="subtitle">Accra, Greater-Accra, Ghana.</p>
            </div>
          </div>
          <div className="contact-list">
            <img
              src="https://freepngimg.com/thumb/android/64743-mobile-phones-client-mail-android-email.png"
              alt="icon-img"
            />
            <div>
              <p className="title">Email:</p>
              <p className="subtitle">bzak954@gmail.com</p>
            </div>
          </div>
          <div className="contact-list">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3moO3XX4C8_0y4n2bbt2yIEtz5dpYHLRTIJyQ36_INU4RlXoO5p-Tmx5FUhnto5R6g54&usqp=CAU"
              alt="icon-img"
            />
            <div>
              <p className="title">Phone Number:</p>
              <p className="subtitle">+233 209 688 728</p>
            </div>
          </div>
        </div>

        <div className="contact-right">
          <form method="post" className="form" role="form">
            <div className="row">
              <div>
                <label for="name">Your Name</label>
                <br />
                <input
                  type="text"
                  className="form-inputs"
                  name="name"
                  id="name"
                  required
                />
              </div>
              <div className="form-group">
                <label for="name">Your Email</label>
                <br />
                <input
                  type="email"
                  className="form-inputs"
                  name="email"
                  id="email"
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <label for="name">Subject</label>
              <br />
              <input
                type="text"
                className="form-inputs"
                name="subject"
                id="subject"
                required
              />
            </div>
            <div className="form-group">
              <label for="name">Message</label>
              <br />
              <textarea
                name="message"
                className="form-text"
                rows="6"
                required
              ></textarea>
            </div>
            {/* <div class="my-3">
                <div class="loading">Loading</div>
                <div class="error-message"></div>
                <div class="sent-message">Your message has been sent. Thank you!</div>
              </div> */}
            <div className="text-center">
              <motion.button
                whileTap={{
                  scale: 0.95,
                  backgroundColor: "#67F6E7",
                  border: "none",
                  color: "#000",
                }}
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 1.5 } }}
                type="submit"
              >
                Send Message
              </motion.button>
            </div>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default Contact;
